module.exports = __webpack_public_path__ + "img/logo.33c5771b.png";